module.exports = __webpack_public_path__ + "img/venew.bf1c3b88.png";